import styled from 'styled-components';
import { Button, useToast } from '@/ui';
import { useCreatorsHub } from '@/hooks';

const Panel = styled.section`
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.glassBg};
  padding: 14px;
`;
const Title = styled.h2` margin: 0 0 12px; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textPrimary}; `;
const Row = styled.div` display: flex; align-items: center; gap: 10px; padding: 8px 0; border-top: 1px solid ${({ theme }) => theme.color.glassBorder}; &:first-of-type { border-top: none; } `;
const Info = styled.div` flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; `;
const EvTitle = styled.span` color: ${({ theme }) => theme.color.textPrimary}; font-size: ${({ theme }) => theme.fontSize.sm}; font-weight: 600; `;
const EvDate = styled.span` color: ${({ theme }) => theme.color.accentCyan}; font-size: ${({ theme }) => theme.fontSize.xs}; `;
const Blurb = styled.span` color: ${({ theme }) => theme.color.textMuted}; font-size: ${({ theme }) => theme.fontSize.xs}; `;

export function UpcomingEventsPanel() {
  const { events } = useCreatorsHub();
  const toast = useToast();
  return (
    <Panel>
      <Title>Upcoming Events</Title>
      {events.map((ev) => (
        <Row key={ev.id}>
          <Info><EvTitle>{ev.title}</EvTitle><EvDate>{ev.date}</EvDate><Blurb>{ev.blurb}</Blurb></Info>
          <Button variant="ghost" size="sm" onClick={() => toast('RSVP confirmed')}>RSVP</Button>
        </Row>
      ))}
    </Panel>
  );
}
